import React from "react";
import styled from "@emotion/styled";
import NavBar from "./components/navbar.jsx";

class Vet extends React.Component {
  constructor(props) {
    // Initialize mutable state
    super(props);
    this.state = {
      salaries: [],
    };
  }

  // Process when the webpage is called
  componentDidMount() {
    // Check if user is logged in
    fetch("/api/v1/salaryvet", { credentials: "same-origin" })
      .then((response) => {
        if (!response.ok) throw Error(response.statusText);
        return response.json();
      })
      .then((data) => {
        this.setState({
          salaries: data.salaries,
        });
      })
      .catch((error) => console.log(error));
  }

  handleAccept = (salaryId) => {
    // Handle accept logic
    console.log("Accepted Salary ID:", salaryId);
    const jsonData = {
      status: "approved",
    };
    // Submit the form
    fetch(`/api/internal/v1/salary/` + salaryId, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData),
    }).then((response) => {
      //check response
      if (response.ok) {
        console.log("Success");
      } else {
        // Handle signup failure, show error message
        console.log("Failed");
      }
    });
  };

  handleReject = (salaryId) => {
    // Handle reject logic
    console.log("Rejected Salary ID:", salaryId);

    const jsonData = {
      status: "rejected",
    };
    // Submit the form
    fetch(`/api/internal/v1/salary/` + salaryId, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData),
    }).then((response) => {
      //check response
      if (response.ok) {
        console.log("Success");
      } else {
        // Handle signup failure, show error message
        console.log("Failed");
      }
    });
  };

  render() {
    const { salaries } = this.state;
    return (
      <>
        <MainCol>
          <NavBar />
          <SalariesTable>
            <thead>
              <tr>
                <th>Salary Id</th>
                <th>User Email</th>
                <th>Company EN</th>
                <th>Company AR</th>
                <th>Role EN</th>
                <th>Role AR</th>
                <th>Experience (years)</th>
                <th>Education Level EN</th>
                <th>Education Level AR</th>
                <th>City EN</th>
                <th>City AR</th>
                <th>Country</th>
                <th>Salary</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {salaries.map((salary) => (
                <tr key={salary._id}>
                  <td>{salary._id}</td>
                  <td>{salary.email}</td>
                  <td>{salary.company_name_en}</td>
                  <td>{salary.company_name_ar}</td>
                  <td>{salary.role_en}</td>
                  <td>{salary.role_ar}</td>
                  <td>{salary.experience_in_yrs}</td>
                  <td>{salary.education_level_en}</td>
                  <td>{salary.education_level_ar}</td>
                  <td>{salary.location_city_en}</td>
                  <td>{salary.location_city_ar}</td>
                  <td>{salary.location_country_en}</td>
                  <td>
                    {salary.salary_per_month} {salary.currency_en}
                  </td>
                  <td>
                    <AcceptButton onClick={() => this.handleAccept(salary._id)}>
                      Accept
                    </AcceptButton>
                    <RejectButton onClick={() => this.handleReject(salary._id)}>
                      Reject
                    </RejectButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </SalariesTable>
        </MainCol>
      </>
    );
  }
}

export default Vet;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;
const MainCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SalariesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f0f0f0;
  }

  tr:nth-child(even) {
    background-color: #f8f8f8;
  }
`;

const Button = styled.button`
  padding: 8px 15px;
  margin: 5px;
  border: none;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s;

  &:hover {
    opacity: 0.9;
  }
`;

const AcceptButton = styled(Button)`
  background-color: #4caf50; // Green color for accept button
`;

const RejectButton = styled(Button)`
  background-color: #f44336; // Red color for reject button
`;
